(function(window, httpServiceDefinition) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.HttpService = httpServiceDefinition(
      window.JSON,
      window.$,
      window.Q,
      namespace.log,
      namespace.BackoffStrategyFactory,
      namespace.statusCodes);
})(this, function(JSON, $, Q, log, BackoffStrategyFactory, statusCodes) {
   'use strict';

   $.support.cors = true;

   var REQUEST_TIMEOUT = 10000;
   var NO_RETRY_STATUS_CODES = [
      statusCodes.UnprocessableEntity
   ];

   var HttpService = function(retryStrategyFactory, logFailures) {
      retryStrategyFactory = retryStrategyFactory || BackoffStrategyFactory.create();

      if (typeof logFailures === 'undefined') {
         logFailures = true;
      }

      var get = function(url) {
         var request = {
            url: url,
            type: 'GET',
            contentType: 'application/json',
            crossDomain: true,
            timeout: REQUEST_TIMEOUT
         };
         return Q($.ajax(request)).catch(function(response) {
            if (logFailures && response && response.statusText !== 'timeout') {
               var errorString = '';
               try {
                  errorString = 'Error: ' + JSON.stringify(response, null, 2) + ' Url: ' + url;
               } catch (error) {
                  errorString = '(response failed conversion into a JSON string.)';
               }

               log.logException(errorString);
               return Q.reject(errorString);
            }
         });
      };

      var sendFormDataPost = function(url, data) {
         return sendRequest(url, $.param(data), 'application/x-www-form-urlencoded; charset=UTF-8', 'POST');
      };

      var canRetryFromStatusCode = function(response) {
         if (!response) {
            return true;
         }

         for (var i = 0; i < NO_RETRY_STATUS_CODES.length; i++) {
            if (response.status === NO_RETRY_STATUS_CODES[i]) {
               return false;
            }
         }
         return true;
      };

      var sendRequest = function(url, data, contentType, httpVerb) {
         var retryStrategy = retryStrategyFactory.create();

         var request = {
            url: url,
            type: httpVerb,
            data: data,
            contentType: contentType,
            crossDomain: true,
            timeout: REQUEST_TIMEOUT
         };

         var send = function(retries) {
            var defer = Q.defer();

            Q($.ajax(request)).then(defer.resolve).catch(function(response) {
               if (logFailures && response && response.statusText !== 'timeout') {
                  var errorString = '';
                  try {
                     errorString = 'Error: ' + JSON.stringify(response, null, 2) + ' Url: ' + url + ' Data: ' + JSON.stringify(data, null, 2);
                  } catch (error) {
                     errorString = '(response failed conversion into a JSON string.)';
                  }

                  log.logException(errorString);
               }

               if (canRetryFromStatusCode(response)) {
                  retryStrategy.backoff().then(function() {
                     retries++;
                     defer.notify(retries);
                     send(retries).progress(defer.notify).then(defer.resolve).catch(defer.reject);
                  }).catch(function(retryResponse) {
                     log.logException('Call to ' + url + ' failed after ' + retries + ' retries.');
                     defer.reject(retryResponse);
                  });
               } else {
                  log.logException('Call ' + url + ' failed with no retry status of ' + response.status + '.');
                  defer.reject(response);
               }
            });

            return defer.promise;
         };

         return send(0);
      };

      return {
         get: get,
         sendFormDataPost: sendFormDataPost
      };
   };

   return {
      create: HttpService
   };
});
